import { motion } from "framer-motion";
import { Warning, Users, House, CurrencyCircleDollar, Truck } from "@phosphor-icons/react";

const situations = [
  {
    icon: Warning,
    title: "Facing Foreclosure",
    text: "Behind on your mortgage? We can close quickly and help you avoid the credit damage of foreclosure.",
    span: "md:col-span-4 lg:col-span-6",
  },
  {
    icon: Users,
    title: "Divorce",
    text: "Sell fast and split proceeds cleanly, without drawn-out listings.",
    span: "md:col-span-4 lg:col-span-3",
  },
  {
    icon: House,
    title: "Inherited Property",
    text: "Don't want the burden of a property you inherited? We buy as-is.",
    span: "md:col-span-4 lg:col-span-3",
  },
  {
    icon: CurrencyCircleDollar,
    title: "Behind on Payments",
    text: "Struggling with mortgage, tax, or medical bills? Turn your home equity into cash quickly and get a fresh start.",
    span: "md:col-span-8 lg:col-span-8",
  },
  {
    icon: Truck,
    title: "Relocating",
    text: "New job or moving out of state? Close on your schedule.",
    span: "md:col-span-4 lg:col-span-4",
  },
];

export const Situations = () => (
  <section
    id="situations"
    data-testid="situations-section"
    className="bg-slate-900 py-20 md:py-32 px-6 md:px-12 lg:px-16 text-stone-50"
  >
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl">
        <span className="uppercase text-xs md:text-sm tracking-[0.2em] font-semibold text-emerald-400">
          We're Here To Help
        </span>
        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          We Help Homeowners In Any Situation
        </h2>
        <p className="mt-4 text-base md:text-lg text-slate-300">
          Life happens. Whatever you're facing, we offer a fast, respectful, and confidential way out.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6">
        {situations.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`situation-card-${i + 1}`}
            className={`col-span-full ${s.span} bg-slate-800 p-8 rounded-2xl border border-slate-700 hover:border-emerald-500/50 transition-colors`}
          >
            <div className="h-12 w-12 rounded-xl bg-emerald-500/15 flex items-center justify-center">
              <s.icon weight="duotone" className="h-6 w-6 text-emerald-400" />
            </div>
            <h3 className="font-heading mt-5 text-xl font-semibold text-white">{s.title}</h3>
            <p className="mt-3 text-slate-300 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
